import React from 'react';

export default function EstadisticasKPICards({ totalStros, esteMes, promedioMensual, vencidos }) {
  return (
    <div className="est-kpi-grid">
      {/* Total Siniestros */}
      <div className="est-kpi-card">
        <div className="est-kpi-icon-container" style={{ backgroundColor: 'rgba(66, 195, 186, 0.08)', color: '#0d9488' }}>
          <i className="bi bi-shield-check"></i>
        </div>
        <div className="est-kpi-content">
          <span className="est-kpi-title">Total Siniestros</span>
          <span className="est-kpi-value">{totalStros}</span>
          <span className="est-kpi-subtext">En el rango seleccionado</span>
        </div>
      </div>

      {/* Siniestros Este Mes */}
      <div className="est-kpi-card">
        <div className="est-kpi-icon-container" style={{ backgroundColor: 'rgba(59, 130, 246, 0.08)', color: '#2563eb' }}>
          <i className="bi bi-calendar3"></i>
        </div>
        <div className="est-kpi-content">
          <span className="est-kpi-title">Siniestros Este Mes</span>
          <span className="est-kpi-value">{esteMes}</span>
          <span className="est-kpi-subtext">Mes en curso</span>
        </div>
      </div>

      {/* Promedio Mensual */}
      <div className="est-kpi-card">
        <div className="est-kpi-icon-container" style={{ backgroundColor: 'rgba(139, 92, 246, 0.08)', color: '#7c3aed' }}>
          <i className="bi bi-graph-up-arrow"></i>
        </div>
        <div className="est-kpi-content">
          <span className="est-kpi-title">Promedio Mensual</span>
          <span className="est-kpi-value">{promedioMensual}</span>
          <span className="est-kpi-subtext">Casos por mes</span>
        </div>
      </div>

      {/* Siniestros Vencidos */}
      <div className="est-kpi-card">
        <div className="est-kpi-icon-container" style={{ backgroundColor: 'rgba(239, 68, 68, 0.08)', color: '#dc2626' }}>
          <i className="bi bi-exclamation-triangle-fill"></i>
        </div>
        <div className="est-kpi-content">
          <span className="est-kpi-title">Siniestros Vencidos</span>
          <span className="est-kpi-value" style={{ color: vencidos > 0 ? '#dc2626' : 'inherit' }}>{vencidos}</span>
          <span className="est-kpi-subtext">{vencidos > 0 ? 'Requiere atención' : 'Al día'}</span>
        </div>
      </div>
    </div>
  );
}
